import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import DomainError from '../views/Main/DomainError/DomainError';
import { getDomainTheme } from '../features/shared/shared.action';
import { FETCH_STATUS } from '../types/enums/fetch-status.enum';
import { AppDispatch } from '../redux/Store';
import { useTheme } from '../hooks/useTheme';

const DomainChecker = WrappedComponent => {
  const MyComponent = props => {
    const dispatch = useDispatch<AppDispatch>();
    const { domainTheme, domainThemeFetchStatus } = useTheme();

    useEffect(() => {
      dispatch(getDomainTheme());
    }, [dispatch]);

    return (
      <>
        {!!domainTheme && <WrappedComponent {...props} />}
        {domainThemeFetchStatus === FETCH_STATUS.REJECTED && <DomainError />}
      </>
    );
  };

  return MyComponent;
};

export default DomainChecker;
